import { AbschnittStateKey } from "@ui/states/AbschnittState";
import { AuskunftStateKey } from "@ui/states/AuskunftState";
import { BenutzerStateKey } from "@ui/states/BenutzerState";
import { ConfigStateKey } from "@ui/states/ConfigState";
import { GostKlausurplanungStateKey } from "@ui/states/GostKlausurplanungState";
import { GostLaufbahnplanungStateKey } from "@ui/states/GostLaufbahnplanungState";
import { AbteilungenStateKey } from "@ui/states/kataloge/AbteilungenState";
import { BeschaeftigungsartenStateKey } from "@ui/states/kataloge/BeschaeftigungsartenState";
import { BetriebeStateKey } from "@ui/states/kataloge/BetriebeState";
import { BetriebsartenStateKey } from "@ui/states/kataloge/BetriebsartenState";
import { EinwilligungsartenStateKey } from "@ui/states/kataloge/EinwilligungsartenState";
import { EntlassgruendeStateKey } from "@ui/states/kataloge/EntlassgruendeState";
import { ErzieherartenStateKey } from "@ui/states/kataloge/ErzieherartenState";
import { FaecherStateKey } from "@ui/states/kataloge/FaecherState";
import { FahrschuelerartenStateKey } from "@ui/states/kataloge/FahrschuelerartenState";
import { FloskelgruppenStateKey } from "@ui/states/kataloge/FloskelgruppenState";
import { FloskelnStateKey } from "@ui/states/kataloge/FloskelnState";
import { FoerderschwerpunkteStateKey } from "@ui/states/kataloge/FoerderschwerpunkteState";
import { HaltestellenStateKey } from "@ui/states/kataloge/HaltestellenState";
import { HerkunftschulenStateKey } from "@ui/states/kataloge/HerkunftschulenState";
import { JahrgaengeStateKey } from "@ui/states/kataloge/JahrgaengeState";
import { KindergaertenStateKey } from "@ui/states/kataloge/KindergaertenState";
import { LeitungsfunktionenStateKey } from "@ui/states/kataloge/LeitungsfunktionenState";
import { LernplattformenStateKey } from "@ui/states/kataloge/LernplattformenState";
import { MerkmaleStateKey } from "@ui/states/kataloge/MerkmaleState";
import { OrteStateKey } from "@ui/states/kataloge/OrteState";
import { ReligionenStateKey } from "@ui/states/kataloge/ReligionenState";
import { TelefonartenStateKey } from "@ui/states/kataloge/TelefonartenState";
import { VermerkartenStateKey } from "@ui/states/kataloge/VermerkartenState";
import { NotenmodulStateKey } from "@ui/states/NotenmodulState";
import { NotificationsStateKey } from "@ui/states/NotificationsState";
import { ReportingStateKey } from "@ui/states/ReportingState";
import { SchuleStateKey } from "@ui/states/SchuleState";
import { ServerStateKey } from "@ui/states/ServerState";
import { StateRegistry } from "@ui/states/StateRegistry";
import { StatistikStateKey } from "@ui/states/statistik/StatistikState";
import { UvStateKey } from "@ui/states/UvState";
import { WiedervorlageStateKey } from "@ui/states/WiedervorlageState";

import { abteilungenStateImpl } from "~/states/kataloge/AbteilungenStateImpl";
import { einwilligungsartenStateImpl } from "~/states/kataloge/EinwilligungsartenStateImpl";
import { erzieherartenStateImpl } from "~/states/kataloge/ErzieherartenStateImpl";
import { faecherStateImpl } from "~/states/kataloge/FaecherStateImpl";
import { floskelgruppenStateImpl } from "~/states/kataloge/FloskelgruppenStateImpl";
import { floskelnStateImpl } from "~/states/kataloge/FloskelnStateImpl";
import { haltestellenStateImpl } from "~/states/kataloge/HaltestellenStateImpl";
import { herkunftschulenStateImpl } from "~/states/kataloge/HerkunftschulenStateImpl";
import { jahrgaengeStateImpl } from "~/states/kataloge/JahrgaengeStateImpl";
import { kindergaertenStateImpl } from "~/states/kataloge/KindergaertenStateImpl";
import { lernplattformenStateImpl } from "~/states/kataloge/LernplattformenStateImpl";
import { merkmaleStateImpl } from "~/states/kataloge/MerkmaleStateImpl";
import { telefonartenStateImpl } from "~/states/kataloge/TelefonartenStateImpl";
import { vermerkartenStateImpl } from "~/states/kataloge/VermerkartenStateImpl";

import { abschnittStateImpl } from "./AbschnittStateImpl";
import { auskunftStateImpl } from "./AuskunftStateImpl";
import { benutzerStateImpl } from "./BenutzerStateImpl";
import { configStateImpl } from "./ConfigStateImpl";
import { gostKlausurplanungStateImpl } from "./GostKlausurplanungStateImpl";
import { gostLaufbahnplanungStateImpl } from "./GostLaufbahnplanungStateImpl";
import { beschaeftigungsartenStateImpl } from "./kataloge/BeschaeftigungsartenStateImpl";
import { betriebeStateImpl } from "./kataloge/BetriebeStateImpl";
import { betriebsartenStateImpl } from "./kataloge/BetriebsartenStateImpl";
import { entlassgruendeStateImpl } from "./kataloge/EntlassgruendeStateImpl";
import { fahrschuelerartenStateImpl } from "./kataloge/FahrschuelerartenStateImpl";
import { foerderschwerpunkteStateImpl } from "./kataloge/FoerderschwerpunkteImpl";
import { leitungsfunktionenStateImpl } from "./kataloge/LeitungsfunktionenStateImpl";
import { orteStateImpl } from "./kataloge/OrteStateImpl";
import { religionenStateImpl } from "./kataloge/ReligionenStateImpl";
import { KlassenAuswahlStateKey } from "./klassen/KlassenAuswahlState";
import { klassenAuswahlStateImpl } from "./klassen/KlassenAuswahlStateImpl";
import { KurseAuswahlStateKey } from "./kurse/KurseAuswahlState";
import { kurseAuswahlStateImpl } from "./kurse/KurseAuswahlStateImpl";
import { LehrerAuswahlStateKey } from "./lehrer/LehrerAuswahlState";
import { lehrerAuswahlStateImpl } from "./lehrer/LehrerAuswahlStateImpl";
import { notenmodulStateImpl } from "./NotenmodulStateImpl";
import { notificationStateImpl } from "./NotificationsStateImpl";
import { reportingStateImpl } from "./ReportingStateImpl";
import { SchuelerAuswahlStateKey } from "./schueler/SchuelerAuswahlState";
import { schuelerAuswahlStateImpl } from "./schueler/SchuelerAuswahlStateImpl";
import { schuleStateImpl } from "./SchuleStateImpl";
import { serverStateImpl } from "./ServerStateImpl";
import { statistikStateImpl } from "./statistik/StatistikStateImpl";
import { uvStateImpl } from "./UvStateImpl";
import { wiedervorlageStateImpl } from "./wiedervorlage/WiedervorlageStateImpl";

export function registerStates(): void {
	const registry = StateRegistry.instance;
	registry.addSessionState(BenutzerStateKey, benutzerStateImpl);
	registry.addSessionState(ConfigStateKey, configStateImpl);
	registry.addSessionState(AbschnittStateKey, abschnittStateImpl);
	registry.addSessionState(SchuleStateKey, schuleStateImpl);
	registry.addSessionState(SchuelerAuswahlStateKey, schuelerAuswahlStateImpl);
	registry.addSessionState(LehrerAuswahlStateKey, lehrerAuswahlStateImpl);
	registry.addSessionState(ServerStateKey, serverStateImpl);
	registry.addSessionState(ReportingStateKey, reportingStateImpl);
	registry.addSessionState(WiedervorlageStateKey, wiedervorlageStateImpl);
	registry.addSessionState(AuskunftStateKey, auskunftStateImpl);
	registry.addSessionState(KlassenAuswahlStateKey, klassenAuswahlStateImpl);
	registry.addSessionState(KurseAuswahlStateKey, kurseAuswahlStateImpl);
	registry.addSessionState(GostLaufbahnplanungStateKey, gostLaufbahnplanungStateImpl);
	registry.addSessionState(GostKlausurplanungStateKey, gostKlausurplanungStateImpl);
	registry.addSessionState(UvStateKey, uvStateImpl);
	registry.addSessionState(NotenmodulStateKey, notenmodulStateImpl);
	registry.addSessionState(NotificationsStateKey, notificationStateImpl);
	registry.addSessionState(OrteStateKey, orteStateImpl);
	registry.addSessionState(LeitungsfunktionenStateKey, leitungsfunktionenStateImpl);
	registry.addSessionState(BeschaeftigungsartenStateKey, beschaeftigungsartenStateImpl);
	registry.addSessionState(BetriebeStateKey, betriebeStateImpl);
	registry.addSessionState(BetriebsartenStateKey, betriebsartenStateImpl);
	registry.addSessionState(EntlassgruendeStateKey, entlassgruendeStateImpl);
	registry.addSessionState(FahrschuelerartenStateKey, fahrschuelerartenStateImpl);
	registry.addSessionState(FoerderschwerpunkteStateKey, foerderschwerpunkteStateImpl);
	registry.addSessionState(ReligionenStateKey, religionenStateImpl);
	registry.addSessionState(StatistikStateKey, statistikStateImpl);
	registry.addSessionState(ErzieherartenStateKey, erzieherartenStateImpl);
	registry.addSessionState(HaltestellenStateKey, haltestellenStateImpl);
	registry.addSessionState(KindergaertenStateKey, kindergaertenStateImpl);
	registry.addSessionState(VermerkartenStateKey, vermerkartenStateImpl);
	registry.addSessionState(MerkmaleStateKey, merkmaleStateImpl);
	registry.addSessionState(TelefonartenStateKey, telefonartenStateImpl);
	registry.addSessionState(JahrgaengeStateKey, jahrgaengeStateImpl);
	registry.addSessionState(HerkunftschulenStateKey, herkunftschulenStateImpl);
	registry.addSessionState(AbteilungenStateKey, abteilungenStateImpl);
	registry.addSessionState(EinwilligungsartenStateKey, einwilligungsartenStateImpl);
	registry.addSessionState(LernplattformenStateKey, lernplattformenStateImpl);
	registry.addSessionState(FloskelgruppenStateKey, floskelgruppenStateImpl);
	registry.addSessionState(FloskelnStateKey, floskelnStateImpl);
	registry.addSessionState(FaecherStateKey, faecherStateImpl);
}
